import { AsyncValidatorFn, ValidatorFn } from '@angular/forms';

export class ImageUploadValidation {
  allowedMimeTypes: string;
  allowedImageDimensions: number[];
  validator: ValidatorFn;
  asyncValidator: AsyncValidatorFn;
  // map of instruction text to display to the user with the key being the error key it corresponds to
  instructions: { [errorId: string]: string };

  constructor(
    allowedMimeTypes: string,
    validator: ValidatorFn,
    asyncValidator: AsyncValidatorFn,
    instructions: { [errorId: string]: string },
    allowedImageDimensions: number[],
  ) {
    this.allowedMimeTypes = allowedMimeTypes;
    this.validator = validator;
    this.asyncValidator = asyncValidator;
    this.instructions = instructions;
    this.allowedImageDimensions = allowedImageDimensions;
  }
}
